<template>
    <div class="dsum">
        <h3>{{ t("components.yourSelection") }}</h3>
        <ul>
            <li>
                <span>{{ t("components.ringband") }}</span>
                <span>{{ ringbandPriceFormatted }}</span>
            </li>

            <li v-if="selectedDiamond !== null">
                <span>{{ diamondText }} </span>
                <span>{{ diamondPriceFormatted }}</span>
            </li>

            <li style="margin-top: 6px;">
                <span> {{ totalText }}</span>
                <span>{{ totalPriceFormatted }}</span>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import usePrices from "@/composables/usePrices";
import useStore from "@/composables/useStore";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "SelectionSummary",
    setup() {
        const {
            computed: { selectedDiamond }
        } = useStore();
        const { t } = useI18n();

        const {
            ringbandPriceFormatted,
            diamondPriceFormatted,
            totalPriceFormatted
        } = usePrices();

        const diamondText = computed(() => {
            return `${selectedDiamond.value?.carat} ${t("components.ct")} ${t(
                `diamondProperties.shape.${selectedDiamond.value?.shape}`
            )} / ${t("components.color")}: ${
                selectedDiamond.value?.color
            } / ${t("components.clarity")}: ${selectedDiamond.value?.clarity}`;
        });

        const totalText = t("components.total");

        return {
            t,
            selectedDiamond,
            diamondText,
            ringbandPriceFormatted,
            diamondPriceFormatted,
            totalText,
            totalPriceFormatted
        };
    }
});
</script>

<style>
.dsum {
    margin-top: 30px;
}

.dsum h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    color: #1D1D1B;

}

.dsum ul {
    margin-top: 20px;
    max-width: 40em;
    padding: 0;
    overflow-x: hidden;
    list-style: none;
    color: #1D1D1B;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.dsum ul span:first-child {
    padding-right: 0.33em;
    background: white;
}

.dsum ul span + span {
    float: right;
    padding-left: 0.33em;
    background: white;
}
</style>
